import React from "react";
import {Route, Router, Switch} from "react-router-dom";
import Thread from "./Thread";
import Create from "./Create";
import Online from "./Online";
import ProjectsListing from "../../layouts/Home/Projects/ProjectsListing";
import {slugify} from "../../api-client/core/authentication/utils";

const Routes = props => {

  return (
    <Router {...props}>
      <Switch>
        <Route
          path="/projects/create"
          render={() => (
            <Create
              makeCreatedPitchPath={projectId =>
                `/projects/${projectId}/thread`
              }
            />
          )}
        />
        <Route
          path="/projects/:projectId/thread"
          render={props => (
            <Thread pitchId={props.match.params.projectId} />
          )}
        />
        <Route render={() => <ProjectsListing/>} />

        {/*<All
          onlyForActiveClient
          onlineVideosUrl={`/home/${clientId}/projects/online?client_id=${clientId}`}
          threadUrl={projectId =>
            `/home/${clientId}/projects/${projectId}/thread`
          }
          createUrl={`/home/${clientId}/projects/create`}
        />*/}

      </Switch>
    </Router>
  );
};

export default Routes;
